(function () {
  var SWIPE_PX = 8;

  function initShots(root) {
    var track = root.querySelector('.pfc-card-shots__track');
    var dots = root.querySelectorAll('[data-pfc-shot]');
    if (!track || dots.length < 2) return;

    function slideIndex() {
      var width = track.clientWidth;
      if (!width) return 0;
      return Math.round(track.scrollLeft / width);
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        setActive(slideIndex());
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var index = Number(dot.getAttribute('data-pfc-shot')) || 0;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      });
    });

    var startX = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      moved = false;
    });

    track.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientX - startX) > SWIPE_PX) moved = true;
    });

    track.addEventListener(
      'click',
      function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-pfc-shots]').forEach(initShots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
